var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item pointer border-0 px-0 py-1"},[_c('div',{staticClass:"item py-1 px-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }